import { Fragment } from 'react'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'

import CardWrapper from '../../CardWrapper'
import { CardTextContent, Typography } from 'common/widgets'
import classNames from '../../styles.module.scss'


CardList.propTypes = {
  data: PropTypes.array.isRequired,
}

export default function CardList({ data }) {
  if(isEmpty(data)) {
    return null
  }
  return (
    data.map(service => (
      <CardWrapper key={service.id} data={service}>
        <Typography variant="h4-card" className={classNames.cardTitle}>
          {service.name && (
            <Fragment>
              <span>{service.name.split('/')[0] + ' '}</span>
              {service.name.split('/')[1] && (
                <Fragment>
                  <span className={classNames.desktopSlash}>/</span>
                  <span>{service.name.split('/')[1]}</span>
                </Fragment>
              )}
            </Fragment>
          )}
        </Typography>
        <CardTextContent
          studentAge={{ min: service.static_content.min_student_age, avg: service.static_content.avg_student_age }}
          groupSize={{ avg: service.static_content.avg_students_count, max: service.static_content.max_students_count }}
          languageNiveau={{ max: service.static_content.language_niveau_max, min: service.static_content.language_niveau_min }}
        />
        <div className={classNames.cardDescription}>
          {service.static_content.tooltip.category_description && (
            <Typography variant="small" className={classNames.cardDescriptionText}>
              {service.static_content.tooltip.category_description}
            </Typography>
          )}
          {service.static_content.tooltip.type_description && (
            <Typography variant="small" className={classNames.cardDescriptionText}>
              {service.static_content.tooltip.type_description}
            </Typography>
          )}
          {service.static_content.tooltip.specific_description && (
            <Typography variant="small" className={classNames.cardDescriptionText}>
              {service.static_content.tooltip.specific_description}
            </Typography>
          )}
        </div>
      </CardWrapper>
    ))
  )
}
